export var fetchFn = window.fetch;